import React, { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { Image, Progress } from "antd";
import styles from "../../styles/dashboard.module.scss";
import barchart from "../../data/barchart.json";
import TeamWellnessBar from "../../components/TeamWellnessBar";
import TeamEngagementBar from "../../components/TeamEngagementBar";
import TeamHappinessBar from "../../components/TeamHappinessBar";
import MoodLineChart from "../../components/MoodLineChart";

import { useB2BContext } from "../../context/ContextB2B";
import moment from "moment";
import { authSVC } from "../../services";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

function InsightsSingle() {
  const [pieChartData, setpieChartData] = useState<any[]>([]);
  const [departmentLevel, setdepartmentLevel] = useState<any[]>([]);
  const [overallLevel, setoverallLevel] = useState<any>();
  const [yearlyWellnessIndexes, setYearlyWellnessIndexes] = useState<any>([]);
  const [yearlyEngagementIndexes, setYearlyEngagementIndexes] = useState<any>(
    []
  );
  const [yearlyHappinessIndexes, setYearlyHappinessIndexes] = useState<any>([]);
  const [yearlyMoodOverview, setYearlyMoodOverview] = useState<any[]>([]);
  const { getUserByID } = useB2BContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [year, setYear] = useState(new Date().getFullYear());

  const changeYear = (offset: any) => {
    setYear((prevYear) => prevYear + offset);
  };

  const TeamName = searchParams.get("department");

  useEffect(() => {
    const year: any = moment().format("yyyy");
    if (getUserByID) {
      authSVC
        .yearlyWellnessIndexes({
          year: year,
          department: TeamName,
        })
        .then((res: any) => {
          setYearlyWellnessIndexes(res?.data);
          // console.log(res.data.percentage, "setYearlyWellnessIndexes");
        })
        .catch((err: any) => {
          //message.error(err.response?.data?.error);
        });

      authSVC
        .yearlyHappinessIndexes({
          year: year,
          department: TeamName,
        })
        .then((res: any) => {
          setYearlyHappinessIndexes(res?.data);
          console.log(res.data.data, "setYearlyHappinessIndexes");
        })
        .catch((err: any) => {
          //message.error(err.response?.data?.error);
        });

      authSVC
        .yearlyEngagementIndexes({
          year: year,
          department: TeamName,
        })
        .then((res: any) => {
          setYearlyEngagementIndexes(res?.data);
          console.log(res.data.data, "yearlyEngagementIndexes");
        })
        .catch((err: any) => {
          //message.error(err.response?.data?.error);
        });

      authSVC
        .yearlyMoodOverview({ department: TeamName, year: year })
        .then((res) => {
          setYearlyMoodOverview(res?.data);
          console.log(res?.data, "setYearlyMoodOverview");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getUserByID, TeamName, year]);

  useEffect(() => {
    // console.log(getUserByID._id, "getUserByID");
    console.log(yearlyWellnessIndexes.percentage, "yearlyWellnessIndexes");
    // alert("dd");
  }, [yearlyWellnessIndexes]);

  return (
    <div className={styles.wellness_report_main_wrapper}>
      <div className={"row back_title"}>
        <Image
          src="/img/new/back_arrow.svg"
          preview={false}
          onClick={() => navigate("/insights")}
        />
        <p>{TeamName} Team Wellness</p>
      </div>
      <div className="year_selection_wrapper">
        <div className="flex gap-4 mt-2">
          <button
            className="px-4 py-2 bg-red-500 text-white rounded-lg"
            onClick={() => changeYear(-1)}
          >
            <img
              src="/img/arrowRight_rounded.svg"
              alt=""
              width={20}
              height={20}
            />
          </button>
          <h2 className="text-xl font-bold">Year: {year}</h2>
          <button
            className="px-4 py-2 bg-green-500 text-white rounded-lg"
            onClick={() => changeYear(1)}
          >
            <img
              src="/img/arrowLeft_rounded.svg"
              alt=""
              width={20}
              height={20}
            />
          </button>
        </div>
      </div>
      <div className="top_info">
        <img src="/img/Group19216.svg" alt="" />{" "}
        <p>A lower index value indicates a less confused mental state.</p>
      </div>
      <div className={styles.col_2_div}>
        {/* Left Container */}
        <div className={styles.data_container}>
          <div className={styles.white_bg_wrapper}>
            <div className={styles.info_title}>
              <div className={styles.title_grp}>
                <Text className={styles.title}>Wellness Index</Text>
              </div>
              <div className={styles.title_grp1}>
                <Image
                  className={styles.img}
                  src="/img/new/download_icon.svg"
                  preview={false}
                />
                <Text className={styles.subtitle1}>
                  {yearlyWellnessIndexes?.percentage || 0}% from last month
                </Text>
              </div>
              <div className={styles.graph}>
                <TeamWellnessBar chartData={yearlyWellnessIndexes} />
                {/* <BarChart chartData={barChartWellness} /> */}
              </div>
            </div>
          </div>
        </div>
        {/* Right Container */}
        <div className={styles.data_container}>
          <div className={styles.white_bg_wrapper}>
            <div className={styles.info_title}>
              <div className={styles.title_grp}>
                <Text className={styles.title}>Happiness Index</Text>
              </div>
              <div className={styles.title_grp1}>
                <Image
                  className={styles.img}
                  src="/img/new/download_icon.svg"
                  preview={false}
                />
                <Text className={styles.subtitle1}>
                  {yearlyHappinessIndexes?.percentage || 0}% from last month
                </Text>
              </div>
              <div className={styles.graph}>
                <TeamHappinessBar chartData={yearlyHappinessIndexes} />
                {/* <BarChartHappiness chartData={barChartHappiness} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.col_2_div}>
        {/* Left Container */}
        <div className={styles.data_container}>
          <div className={styles.white_bg_wrapper}>
            <div className={styles.info_title}>
              <div className={styles.title_grp}>
                <Text className={styles.title}>Engagement</Text>
              </div>
              <div className={styles.title_grp1}>
                <Image
                  className={styles.img}
                  src="/img/new/download_icon.svg"
                  preview={false}
                />
                <Text className={styles.subtitle1}>
                  {yearlyEngagementIndexes?.percentage || 0}% from last month
                </Text>
              </div>
              <div className={styles.graph}>
                <TeamEngagementBar chartData={yearlyEngagementIndexes} />
                {/* <BarChartHappiness chartData={barChartHappiness} /> */}
              </div>
            </div>
          </div>
        </div>
        {/* Right Container */}
        <div className={styles.data_container}>
          <div className={styles.white_bg_wrapper}>
            <div className={styles.info_title}>
              <div className={styles.title_grp}>
                <Text className={styles.title}>Team Mood Overview</Text>
              </div>
              {/* <div className={styles.title_grp1}>
                <Image
                  className={styles.img}
                  src="/img/new/download_icon.svg"
                  preview={false}
                />
                <Text className={styles.subtitle1}>21% from last month</Text>
              </div> */}
              <div className={styles.graph}>
                <MoodLineChart chartData={yearlyMoodOverview} />
                {/* <BarChartHappiness chartData={barChartHappiness} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.border}></div>
    </div>
  );
}

export default InsightsSingle;
